<template>
    <div class="included-whilist position-relative">
        <!-- {{get_currencies}} -->
        <notifications class="whitelist" group="whitelist" style="z-index:99999" position="top left" :max="1" v-if="$route.name != 'chart'"/>
        <app-buy-sell v-if="tradeBuySell" :buySellType="buySellType" :currency_pair="currency_pair"></app-buy-sell>
        <app-alerpop v-if="alertTab" :currency_pair="alertSymbol"></app-alerpop>
        <div class="addWatch_list updateWrap d-flex align-items-center justify-content-between border-bottom p-2">
            <ul class="d-flex align-items-center justify-content-between comp-toggle border-0">
                <li>
                    <div class="dropdown">
                        <button type="button" class="btn appButton dropdown-toggle" data-toggle="dropdown">
                            <span style="width : 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{getwatchName(watchId)}}</span>
                        </button>
                        <div class="dropdown-menu myWatchlist">
                            <a @click.prevent="showCreateWatch = !showCreateWatch" class="dropdown-item d-flex align-items-center crtWatlist" href="#">
                            	<feather class="mr-2" size="13px" type="plus-circle"></feather> {{$t('create_new_watchlist') }} 
                            </a>
                            <a class="dropdown-item justify-content-between" href="#" v-for="list in watchListData" @click.prevent="setWatch(list)" :class="[{ 'crtWatlist' : (list._id == watchId) }]">
                                <span style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{list.name}}</span>
                                <span class="d-flex align-items-center" v-if="list._id">
                                    <span @click.stop="editWatchData = list" class="editClose mr-1"><feather size="12px" type="edit"></feather></span>
                                    <span @click.stop="delWatchData = list" class="editClose"><feather class="red" size="13px" type="trash-2"></feather> </span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="addWatchlt openWatchlist d-flex align-items-center" :class="isSearch?'active':' '">
                <a class="showSearch" @click.prevent="isSearch = !isSearch;shoWFev = false;searchPair = ''" href="#" data-title="Search Symbols">
                    <feather size="16px" type="search"></feather>
                </a>
                <a class="hideSearch squreClose" @click.prevent="isSearch = false" href="#" data-title="Close">
                    <feather size="16px" type="x"></feather>
                </a>
                <!-- <a class="ml-2" href="#" data-title="Favorites" @click="shoWFev = !shoWFev;isSearch = false" v-if="watchId" :class="[{'favSelected' : shoWFev}]">
                    <feather size="16px" type="star"></feather>
                </a> -->
                <a class="ml-2" @click="isToggled = !isToggled;isSearch = false" href="#" data-title="One Click Trade">
                    <span v-if="isToggled"><feather size="16px" type="list"></feather> </span>
                    <span v-else @click="filterType = 'ALL'"><feather size="16px" type="grid"></feather> </span>
                </a>
            </div>
        </div>
        <div class="wishlistTable scrollbar@ mt-2" :class="isToggled?'oneClickTrade':''">
            <div class="search_share_sec d-flex align-items-center m-0" v-if="isSearch">
                <feather type="search"></feather>
                <input type="text" class="search_txtin" :placeholder="$t('search_title')" id="search_share1" v-model="searchPair" />
            </div>
            <!-- search List -->
            <div class="customWatch-list border-0" v-show="isSearch">
                <div class="position-relative customPad">
                    <div class="addWatchlist-step scrollbar">
                        <div class="border-bottom position-relative customAret align-items-center d-flex my-0" v-for="spreads in currencyPairsSorted" v-if="spreads.isinid.toLowerCase().includes(searchPair.toLowerCase())">
                            <div class="d-flex align-items-center justify-content-between">
                                <p class="mb-0" @click.prevent="checkSubscribe(spreads.isinid,spreads.mn)">{{spreads.isinid}}</p>
                            </div>
                            <div class="addWatchIcon ml-3 active">
                                <a href="#">
                                    <feather :data-title="(subList.includes(spreads.isinid))?'Remove from the Watchlist':'Add to the Watchlist'" size="14px" :type="(subList.includes(spreads.isinid))?'x':'plus'" @click.prevent="addRemSubscribe(spreads.isinid,spreads.mn)"></feather>
                                </a>
                            </div>
                        </div>
                        <no-data class="noData border-0 h-100 text-center pt-4" v-if="currencyPairs.length == 0 || filtercurr().length == 0" text="No result found"/>
                    </div>
                </div>
            </div>
            <!-- One Click Trade -->
            <div class="wishlistTable scrollbar pb-5" v-show="isToggled">
                <span class="customAction mb-1" v-for="(spreads,index) in dataList(get_currencies)" @dragstart="drag($event,{'key':spreads.other.isinid, 'mn':spreads.other.mn})" draggable="true">
                    <p class="text-center currencyPath px-3 m-0 p-0">
                        <span class="f-14 font-weight-bold">{{spreads.other.mn}}</span>
                        <span class="font-weight-bold" :class="[{'red':(spreads.B - spreads.other.closepx) < 0 ,'green':(spreads.B - spreads.other.closepx) > 0}]">
                            {{parseFloat((spreads.B - spreads.other.closepx).toFixed(5))}}
                            ({{parseFloat((((spreads.B - spreads.other.closepx)/spreads.other.closepx)*100).toFixed(2))}}%)
                        </span>
                    </p>
                    <!-- <p>
                        {{spreads.other.isinid}}, {{parseFloat((spreads.B - spreads.other.closepx).toFixed(3))}}
                        ({{parseFloat((((spreads.B - spreads.other.closepx)/spreads.other.closepx)*100).toFixed(3))}}%)
                    </p> -->
                    <div class="form-data d-flex align-items-center" @click.stop.prevent="">
                        <div class="form-fields d-flex align-items-center midSpace" :id="spreads.other.isinid+'_form_SL'">
                            <label>{{$t('sl') }} </label>
                            <div class="onclick-input" v-if="onClickList[spreads.other.isinid]">
                                <a href="#" @click.prevent="changeStep(spreads.other.isinid,1,'SL')"><feather type="plus"></feather> </a>
                                    <input type="number" :step="getStep(onClickList[spreads.other.isinid].SL,spreads)" min="0" placeholder="0.00" :id="spreads.other.isinid+'_SL'" v-model="onClickList[spreads.other.isinid].SL" @input="changeValidation(spreads.other.isinid,onClickList[spreads.other.isinid].SL,'SL',spreads); removeErrorMsg(spreads.other.isinid+'_form_SL')" maxlength="11" @keyup="keyUpStep($event,spreads.other.isinid,'SL')"/>
                                <a class="minus" href="#" @click.prevent="changeStep(spreads.other.isinid,0,'SL')"><feather type="minus"></feather> </a>
                            </div>
                            <input type="number" step="0.01" min="0" placeholder="0.00" v-else/>
                        </div>
                        <div class="form-fields d-flex align-items-center midSpace" :id="spreads.other.isinid+'_form_TP'">
                            <label>{{$t('tp') }} </label>
                            <div class="onclick-input" v-if="onClickList[spreads.other.isinid]">
                                <a href="#" @click.prevent="changeStep(spreads.other.isinid,1,'TP')"><feather type="plus"></feather> </a>
                                <input type="number" :step="getStep(onClickList[spreads.other.isinid].TP,spreads)" min="0" placeholder="0.00" :id="spreads.other.isinid+'_TP'" v-model="onClickList[spreads.other.isinid].TP" @input="changeValidation(spreads.other.isinid,onClickList[spreads.other.isinid].TP,'TP',spreads); removeErrorMsg(spreads.other.isinid+'_form_TP')" maxlength="11" @keyup="keyUpStep($event,spreads.other.isinid,'TP')"/>
                                <a class="minus" href="#" @click.prevent="changeStep(spreads.other.isinid,0,'TP')"><feather type="minus"></feather> </a>
                            </div>
                            <input type="number" step="0.01" min="0" placeholder="0.00" v-else/>
                        </div>
                    </div>
                    
                    <div class="form-data d-flex align-items-center" @click.stop.prevent="">
                        <a href="#" class="button-fields redBG midSpace" @click.prevent="oneClickOrder(spreads.other.isinid,0,spreads)"><!-- orderPlced = !orderPlced -->
                            <span class="sm">{{$t('sell') }}  </span>
                            <p class="mb-0 f-12">{{parseFloat(parseFloat(spreads.B || 0).toFixed(5))}}</p>
                        </a>
                        <div class="button-fields form-fields p-0 midSpace" :id="spreads.other.isinid+'_form_lot'">
                            <div class="onclick-input outMid" v-if="onClickList[spreads.other.isinid]">
                                
                                <template v-if="userSettings.position_size && userSettings.position_size == '1'">
                                    <a href="#"><feather type="plus" @click.prevent="changeStep(spreads.other.isinid,1,'units')"></feather> </a>
                                    <input type="number" :step="spreads.other.Min_Trade_Size * spreads.other.market_ContractSize" :min="spreads.other.Min_Trade_Size * spreads.other.market_ContractSize" :placeholder="spreads.other.Min_Trade_Size * spreads.other.market_ContractSize" :name="spreads.other.isinid+'_units'" :id="spreads.other.isinid+'_units'" v-model="onClickList[spreads.other.isinid].units" class="boxInput" maxlength="10"/>
                                    <!-- @focus=""  @input="quantityValidation(spreads.other.isinid,onClickList[spreads.other.isinid].lot,spreads); removeErrorMsg(spreads.other.isinid+'_form_lot')" -->
                                    <a class="minus" href="#" @click.prevent="changeStep(spreads.other.isinid,0,'units')"><feather type="minus"></feather> </a>
                                </template>
                                <template v-else>
                                    <a href="#"><feather type="plus" @click.prevent="changeStep(spreads.other.isinid,1,'lot')"></feather> </a>
                                    <input type="number" :step="spreads.other.Min_Trade_Size" :min="spreads.other.Min_Trade_Size" :placeholder="spreads.other.Min_Trade_Size" :name="spreads.other.isinid+'_lot'" :id="spreads.other.isinid+'_lot'" v-model="onClickList[spreads.other.isinid].lot" class="boxInput" @input="quantityValidation(spreads.other.isinid,onClickList[spreads.other.isinid].lot,spreads); removeErrorMsg(spreads.other.isinid+'_form_lot')" maxlength="10"/><!--  @focus=""  -->
                                    <a class="minus" href="#" @click.prevent="changeStep(spreads.other.isinid,0,'lot')"><feather type="minus"></feather> </a>
                                </template>
                            </div>
                            <input type="number" step="0.01" min="0" placeholder="0.01" :name="spreads.other.isinid+'_lot'" :id="spreads.other.isinid+'_lot'" v-else/>
                        </div>
                        <a href="#" class="button-fields greenBG midSpace" @click.prevent="oneClickOrder(spreads.other.isinid,1,spreads)"><!-- orderPlced = !orderPlced -->
                            <span class="sm">{{$t('buy') }}  </span>
                            <p class="mb-0 f-12">{{parseFloat(parseFloat(spreads.A || 0).toFixed(5))}}</p>
                        </a>
                    </div>
                </span>
            </div>
            <!-- price feed -->
            <div class="customWatch-list border-0" v-show="!isSearch && !isToggled">
                <div class="position-relative customPad">
                    <div class="scrollbar favItem mb-2">
                        <ul class="d-flex align-items-center comp-toggle border-0">
                            <li :class="(filterType == 'ALL')?'active':' '"><a data-toggle="pill" @click.prevent="filterType = 'ALL' " href="#all"> {{$t('all')}} </a></li>
                            <li :class="(filterType == 'Forex')?'active':' '"><a data-toggle="pill" @click.prevent="filterType = 'Forex' " href="#Forex">{{$t('fx')}}</a></li>
                            <li :class="(filterType == 'Shares')?'active':' '" v-if="enableShares"><a data-toggle="pill" @click.prevent="filterType = 'Shares' " href="#Shares">{{$t('stocks')}}</a></li>
                            <!-- <li :class="(filterType == 'Shares')?'active':' '"><a data-toggle="pill" @click.prevent="filterType = 'Shares' " href="#Shares">Shares</a></li>
                             -->
                            <li :class="(filterType == 'INDICIES')?'active':' '"><a data-toggle="pill" @click.prevent="filterType = 'INDICIES' " href="#fx"> {{$t('indices')}}</a></li>
                            <li :class="(filterType == 'Commodities')?'active':' '"><a data-toggle="pill" @click.prevent="filterType = 'Commodities' " href="#indexes">{{$t('comm')}}</a></li>
                            <li :class="(filterType == 'crypto')?'active':' '" v-if="enableCrypto"><a data-toggle="pill" @click.prevent="filterType = 'crypto' " href="#indexes">{{$t('cryptos')}}</a></li>
                        </ul>
                    </div>
                    <div class="addWatchlist-step-head d-flex align-items-center justify-content-between border-bottom">
                        <p class="">{{$t('symbol')}}</p>
                        <p class="ml-4">{{$t('bid')}}</p>
                        <p >{{$t('ask')}}</p>
                        <p class="spd text-right pr-3" v-if="!(userSettings.position_size && userSettings.display_spread == '0')">{{$t('spread')}}</p>
                    </div>
                    <div class="addWatchlist-step scrollbar">
                        <div
                            class="border-bottom mb-2 position-relative customAret align-items-center"
                            :class="[{'d-flex my-0' : isSearch}]"
                            v-for="(spreads,index) in dataList(get_currencies)"
                            @dragstart="drag($event,{'key':spreads.other.isinid, 'mn':spreads.other.mn})"
                            draggable="true"
                        >

                            <div class="arealeft d-flex align-items-center justify-content-between" :class="[{'' : !isSearch}]">
                                <p :class="['mb-0 mr-1', product == 'Capital-Street' ? 'text-13' : '']">{{spreads.other.isinid}}</p>
                                <p class="mb-0 " :class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}, product == 'Capital-Street' ? 'text-13' : '']">{{Number(spreads.B || 0).toFixed((((spreads.other.Tick_Size || '').split('.')[1] || '').length) || 1)}}</p>
                                <p class="mb-0" :class="[{'green': spreads.sell_increase_staus}, {'red': !spreads.sell_increase_staus}, product == 'Capital-Street' ? 'text-13' : '']">{{Number(spreads.A || 0).toFixed((((spreads.other.Tick_Size || '').split('.')[1] || '').length) || 1)}}</p>
                                <p class="withBG opc-7 mb-0" :class="[product == 'Capital-Street' ? 'text-13' : '']" v-if="!(userSettings.position_size && userSettings.display_spread == '0')">{{parseFloat((spreads.SPREAD/spreads.other.pip_size).toFixed(1))}}</p>
                                <!-- v-if="!(userSettings.position_size && userSettings.display_spread == '0')" -->
                            </div>
                            <div class="clickActive" @click.prevent="changeChart(spreads.other.isinid)">
                                <div class="d-flex align-items-center justify-content-between">
                                    <p class="m-0 d-flex align-items-center"></p>
                                    <div class="p-text d-flex align-items-center maskIcon">
                                        <a href="javascript:void(0)" @click="alertSymbol = spreads.other.isinid; alertTab = true"><span class="maskElement alertIcon"></span></a>
                                        <router-link :to="{path:'/scrip-detail',query:{'market': spreads.other.isinid}}"><feather type="alert-circle"></feather> </router-link>
                                        <a href="#" @click.stop.prevent="changeChart(spreads.other.isinid)"><feather type="bar-chart-2"></feather> </a>
                                        <!-- <a href="#" v-if="watchId" :class="[{'favSelected' : fevList.includes(spreads.other.isinid)}]">
                                        	<feather type="star" @click.stop.prevent="addRemFev(spreads.other.isinid)"></feather>
                                        </a> -->
							
                            <a class="sell" href="#" @click.prevent.stop="openBuySell('sell',spreads.other.isinid)">{{$t('s') }}</a>
                                        <a class="buy" href="#" @click.prevent.stop="openBuySell('buy',spreads.other.isinid)">{{$t('b') }}</a>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <no-data class="noData pt-4" v-if="dataList(get_currencies).length == 0" :text="(subList.length > 0)?'Please add symbols to the list':'Please add symbols to the list'"/>
                    </div>
                </div>
            </div>
        </div>

        <!--Add New WatchList-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="showCreateWatch">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <app-loader v-if="pageLoader"/>
                <span class="closePOP" @click.prevent="clearCreateWatch()"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">{{$t('new_watchlist') }}</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-if="watchListData.length >= 6">
                    <div class="fields-wrapper">
                        <div class="ppSuccess-icon text-center mt-0 mb-2 d-flex align-items-center justify-content-center">
                            <feather size="28px" type="info"></feather>
                        </div>
                        <h3 class="mb-3">{{$t('maximum_5_watchlists') }} </h3>
                        <!-- <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="clearCreateWatch()">Create New Watchlist</button> -->
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 updateWrap" v-else-if="!createWatchSuccess">
                    <div class="form-fields">
                        <input type="text" class="form-controls" :placeholder="$t('enter_watchlist_name')" name="Watchlist Name" v-model="newWatchName" v-validate="'required|max:25'" maxlength="25"/>
                        <span class="text-danger" v-if="submitted && errors.has('Watchlist Name')">{{ errors.first('Watchlist Name') }}</span>
                        <button class="btn appButton linkBG mx-auto justify-content-center mt-4" @click="AdWAtch()" :disabled="pageLoader">{{$t('watchlist_create') }} </button>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <div class="fields-wrapper">
                        <div class="ppSuccess-icon text-center mt-0 mb-2 d-flex justify-content-center align-items-center">
                            <feather size="28px" type="check-circle"></feather>
                        </div>
                        <h3 class="mb-3 green">{{$t('new_watchlist_successfully') }} </h3>
                        <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="clearCreateWatch()">{{$t('close') }}</button>
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Delete WatchList-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="Object.keys(delWatchData).length > 0">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <app-loader v-if="pageLoader"/>
                <span class="closePOP" @click.prevent="delWatchData = {};delWatchSuccess = false"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">{{$t('delete_watchlist') }} </p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-if="!delWatchSuccess">
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mt-0 mb-2 d-flex justify-content-center align-items-center">
                            <feather class="red" size="28px" type="trash-2"></feather>
                        </div>
                        <h3 class="mb-3">{{$t('delete_watchlist?') }} </h3>
                        <div class="d-flex align-items-center justify-content-center mt-4">
                            <button href="#" class="red noAdd mr-3" @click="delWatchData = {}">{{$t('no') }}</button>
                            <button class="btn appButton linkBG justify-content-center" @click="delWAtch()">{{$t('yes') }}</button>
                        </div>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mb-3">
                            <div class="checkmarkAnimated">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 161.2 161.2" enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                                <path class="path" fill="none" stroke="#10bd72" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                                    c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                                    c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"/>
                                <circle class="path" fill="none" stroke="#10bd72" stroke-width="4" stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1"/>
                                <polyline class="path" fill="none" stroke="#10bd72" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 
                                    74.1,108.4 48.2,86.4 "/>

                                <circle class="spin" fill="none" stroke="#10bd72" stroke-width="4" stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6" r="73.9"/>

                                </svg>
                            </div>
                        </div>
                        <h3 class="mb-3 green">{{$t('delete_watchlist_successfully') }} </h3>
                        <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="delWatchData = {};delWatchSuccess = false">{{$t('close') }} </button>
                    </div>
                </div>
            </div>
        </div>
        <!--Edit WatchList-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="Object.keys(editWatchData).length > 0">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <app-loader v-if="pageLoader"/>
                <span class="closePOP" @click.prevent="editWatchData = {};editWatchSuccess = false"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">{{$t('edit_watchlist') }} </p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 updateWrap" v-if="!editWatchSuccess">
                    <div class="form-fields">
                        <input type="text" class="form-controls" :placeholder="$t('enter_watchlist_name')" name="Watchlist Name" v-model="editWatchData.name" v-validate="'required|max:25'" maxlength="25"/>
                        <span class="text-danger" v-if="submitted && errors.has('Watchlist Name')">{{ errors.first('Watchlist Name') }}</span>
                        <button class="btn appButton linkBG mx-auto justify-content-center mt-4" @click="editWAtch()" :disabled="pageLoader">{{$t('update') }}</button>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mt-0 mb-3 d-flex justify-content-center align-items-center">
                            <div class="checkmarkAnimated">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 161.2 161.2" enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                                <path class="path" fill="none" stroke="#10bd72" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                                    c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                                    c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"/>
                                <circle class="path" fill="none" stroke="#10bd72" stroke-width="4" stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1"/>
                                <polyline class="path" fill="none" stroke="#10bd72" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 
                                    74.1,108.4 48.2,86.4 "/>

                                <circle class="spin" fill="none" stroke="#10bd72" stroke-width="4" stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6" r="73.9"/>

                                </svg>
                            </div>
                        </div>
                        <h3 class="mb-3 green">{{$t('watchlist_updated_successfully') }} </h3>
                        <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="editWatchData = {};editWatchSuccess = false">{{$t('close') }} </button>
                    </div>
                </div>
            </div>
        </div>
        <!--Delete Symbol-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="symbolWatchlist">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="symbolWatchlist = false"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">{{$t('delete_symbol') }}</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap">
                    <div class="fields-wrapper">
                        <h3 class="mb-3">{{$t('are_sure_delete_symbol') }}</h3>
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto">{{$t('yes') }}</a>
                        <a href="#" class="noAdd">{{$t('no') }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="editsymbol">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="editsymbol = false"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">{{$t('symbol_name') }}</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 updateWrap">
                    <div class="form-fields">
                        <input type="text" class="form-controls" :placeholder="$t('commodities')" />
                        <a href="#" class="btn appButton linkBG mx-auto justify-content-center mt-4">{{$t('edit_symbol') }}</a>
                    </div>
                </div>
            </div>
        </div>

        <!--Sell Oreder PLaces -->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="orderPlced">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="orderPlced = false"><feather size="13px" type="x"></feather></span>

                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-if="!wsOrder.hasOwnProperty(tempOrderId)">
                    <div class="fields-wrapper">
                        <div class="ppSuccess-icon text-center mb-2 d-flex justify-content-center">
                            <feather size="28px" type="clock"></feather>
                        </div>
                        <h3 class="mb-3">{{$t('placed_order_pending_wait') }}</h3>
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="orderPlced = false">{{$t('go_to_order') }}</a>
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <div class="fields-wrapper">
                        <div class="ppSuccess-icon text-center mb-2 d-flex justify-content-center">
                            <feather size="28px" type="check-circle" v-if="wsOrder[tempOrderId].stat == 'OK'"></feather>
                            <feather size="28px" type="alert-triangle" v-else></feather>
                        </div>
                        <h3 class="mb-3" :class="(wsOrder[tempOrderId].stat == 'OK')?'green':'red'">{{wsOrder[tempOrderId].resp_msg}}</h3><!--  :class="(wsOrder.stat == 'OK')?'green':'red'" -->
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="orderPlced = false">{{$t('go_to_order') }}</a>
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import buy_sell from './buy-sell'
import app_alerpop from './price-alert'
import { Const } from '@/plugins/vue-provider-cache/const.mod'
import { commonAllmixins } from '@/plugins/commonAll'
const product = process.env.product;
export default {
    name: 'watchlist',
    mixins: [commonAllmixins],
    data() {
        return {
            currencyType: 'ALL',
			order: 'open',
			rightTabs: 'watchlist',
			accordian: '1',
			newsType:false,
			indexNo: '',
			buyType: 'Market',
			buySellType: 'buy',
			technicals: 'daily',
			page : '1',
			buySell: '',
			symbolWatchlist: false,
			editsymbol: false,
			tradeBuySell: false,
			isSearch: false,
			isToggled: false,
			filterOption: false,
			alertTab: false,
			alertSymbol: '',
			myWatchlist: false,
			editWatchlist: false,
			delWatchlist: false,
			modifyOrder: true,
			pendingOrder: false,
			setActive: false,

			pageLoader : false,
			currency_pair : '',
			submitted : false,
			// watchlist
			watchbtnShow : [],
			subList : [],
			watchId :null,
			// creat watch List
			showCreateWatch : false,
			newWatchName : '',
			createWatchSuccess : false,
			// delete watch List
			delWatchData : {},
			delWatchSuccess : false,
			// Update watch List
			editWatchData : {},
			editWatchSuccess : false,
			// fevorite List
			shoWFev : false,
			fevList :[],
            // one click trade
            onClickList : {},
			orderPlced: false,
            orderPending : {},
            tempOrderId : '',
            // search isins pair to add watch
            searchPair : '',
            // filter pricefeed list
            filterType : 'ALL', //'ALL','currencies','INDICIES','Commodities'
            // onclickError : {}
            product
        }
    },
    components:{
    	appBuySell : buy_sell,
        appAlerpop : app_alerpop
    },
    watch:{
        subList(val){
            // console.log('watchList==============>',val)
            // this.changeClickList()
            this.callWatchList(val)
        },
        userSettings(val){
            // if(this.userSettings.lotsize){
            //     this.changeClickList()
            // }
        },
        isToggled(val){
            this.changeClickList()
        },
        isSearch(val){
            if(!val && this.isToggled){
                this.changeClickList();
            }
        }
    },
    props:['loadChart'],
    emits:['clearAll'],
    methods:{
        changeChart(val){
            let isinid = val
            let data = { 'key': val, 'mn':""}
            try{
                data.mn =(this.currencyPairs.find(value=>value.isinid.toLowerCase() == val.toLowerCase()) || {}).mn || val;
            }catch(e){}
            // console.log(data)
            this.$emit("input", data)
            this.$emit("clearAll")
        },
        filtercurr(){
            try{
                return this.currencyPairs.filter(spreads=> spreads.isinid.toLowerCase().includes(this.searchPair.toLowerCase()))
            }catch(e){return []}
        },
        keyUpStep(e,name,varName){
            if(parseFloat(this.onClickList[name][varName]) == 0 && e.key == 'ArrowDown'){
                this.onClickList[name][varName] = this.get_currencies[name].A
            }
            // e.preventDefault();
        },
        changeStep(name,type,varName){
            if(type == 1){
                document.getElementById(name+"_"+varName).stepUp()
                this.onClickList[name][varName] = document.getElementById(name+"_"+varName).value
            }else if(type == 0){
                if(['SL','TP'].includes(varName) && !this.onClickList[name][varName] ){
                    this.onClickList[name][varName] = this.get_currencies[name].A
                }else{
                    document.getElementById(name+"_"+varName).stepDown()
                    this.onClickList[name][varName] = document.getElementById(name+"_"+varName).value
                }
            }
        },
        getStep(val,instruments){
            let data = instruments.A
            if(val == '' || parseFloat(val) == 0){
                return (parseFloat(data)).toString()
            }else if(val && data.toString().includes('.')){
                return 1/Math.pow(10, data.toString().split('.')[1].length)
            }else{
                return '1'
            }
        },
        quantityValidation(spreads,val,instruments){
            this.onClickList[spreads].lot = val.toString().replaceAll(/[^\d.]/g, '')
            let upper = 3, lower = 3;
            try{ upper = instruments.other.Max_Trade_Size.length}catch(e){}
            try{ lower = instruments.other.Min_Trade_Size.split('.')[1].length}catch(e){}
            if(val.toString().includes('.')){
                this.onClickList[spreads].lot = val.toString().split('.')[0].slice(0,upper) + '.' + val.toString().split('.')[1].slice(0,lower)
            }else{
                this.onClickList[spreads].lot = val.toString().slice(0,upper)
            }
        },
        changeValidation(spreads,val,name,instruments){
            this.onClickList[spreads][name] = val.toString().replaceAll(/[^\d.]/g, '')
            let upper = 5, lower = 5;
            try{ upper = instruments.B.split('.')[0].length}catch(e){}
            try{ lower = instruments.other.Tick_Size.split('.')[1].length}catch(e){}
            if(val.toString().includes('.')){
                this.onClickList[spreads][name] = val.toString().split('.')[0].slice(0,upper) + '.' + val.toString().split('.')[1].slice(0,lower)
            }else{
                this.onClickList[spreads][name] = val.toString().slice(0,upper)
            }
        },
    	// plintData(spreads){ console.log(JSON.stringify(spreads))},
        successWs(){
            this.orderPlced = true
        },
        failedWs(){
            this.displayError('some network issue','error')
            // this.orderPending = ''
            // this.tempOrderId = {}
            // console.log('failed order')
        },
        displayError(getMessage,type){
			this.$notify({
				group: 'foo',
				type: (type && type == null)?'error':type,
				text: getMessage,
				duration: 2000,
				closeOnClick: true
			});
		},
        addErrorMsg(id){
            if(!$("#"+id).hasClass("validation-error")){
                $("#"+id).addClass("validation-error")
            }
        },
        removeErrorMsg(id){
            if($("#"+id).hasClass("validation-error")){
                $("#"+id).removeClass("validation-error")
            }
        },
        oneclickError(getMessage,type){
            this.$notify({
                group: 'whitelist',
                type: (type && type == null)?'error':type,
                text: getMessage,
                duration: 4000,
                closeOnClick: true
            });
        },
        oneClickOrder(spreads,side,priceData){
            this.removeErrorMsg(spreads+'_form_SL');
            this.removeErrorMsg(spreads+'_form_TP');
            this.removeErrorMsg(spreads+'_form_lot');
            let _that = this
            // function validateQuantity(quantity, minLotSize) {
            //     if (quantity % minLotSize !== 0) {
            //         _that.addErrorMsg(spreads+'_form_lot');
            //         _that.oneclickError(`Quantity must be a multiple of the minimum lot size (${minLotSize}).`,'error');
            //         return false;
            //     }
            //     return true;
            // }
            function isDivisible(quantity, minLot, precision = 10) {
                const scale = Math.pow(10, precision);
                const scaledQuantity = Math.round(quantity * scale);
                const scaledMinLot = Math.round(minLot * scale);
                return scaledQuantity % scaledMinLot === 0;
            }
            if(this.onClickList[spreads] && this.onClickList[spreads].lot && this.onClickList[spreads].lot > 0){
                if(side == 1){
                    if(!(this.onClickList[spreads].SL < priceData.A) || this.onClickList[spreads].SL < 0){
                        document.getElementById(spreads+'_SL').focus();
                        this.addErrorMsg(spreads+'_form_SL');
                        this.oneclickError('Stop loss must be null or less then Sell Price','error')
                        return
                    }
                    if((!(this.onClickList[spreads].TP > priceData.A) || this.onClickList[spreads].TP < 0) && !(this.onClickList[spreads].TP == 0)){
                        document.getElementById(spreads+'_TP').focus();
                        this.addErrorMsg(spreads+'_form_TP');
                        this.oneclickError('Target price must be null or greater then Sell Price','error')
                        return
                    }
                }else if(side == 0){
                    if((!(this.onClickList[spreads].SL > priceData.B) || this.onClickList[spreads].SL < 0) && !(this.onClickList[spreads].SL == 0)){
                        document.getElementById(spreads+'_SL').focus();
                        this.addErrorMsg(spreads+'_form_SL');
                        this.oneclickError('Stop loss must be null or greater then Buy Price','error')
                        return
                    }
                    if(!(this.onClickList[spreads].TP < priceData.B) || this.onClickList[spreads].TP < 0){
                        document.getElementById(spreads+'_TP').focus();
                        this.addErrorMsg(spreads+'_form_TP');
                        this.oneclickError('Target price must be null or less then Buy Price','error')
                        return
                    }
                }
                if(!isDivisible(this.onClickList[spreads].lot,priceData.other.Min_Trade_Size)){
                    this.addErrorMsg(spreads+'_form_lot');
                    this.oneclickError(`Quantity must be a multiple of the minimum lot size ${priceData.other.Min_Trade_Size}.`,'error');
                    return;
                }
                if(!isDivisible(this.onClickList[spreads].units / priceData.other.market_ContractSize,priceData.other.Min_Trade_Size)){
                    this.addErrorMsg(spreads+'_form_unit');
                    this.oneclickError(`Unit must be a multiple of the minimum Unit size ${priceData.other.Min_Trade_Size * priceData.other.market_ContractSize}.`,'error');
                    return;
                }
                if(this.userSettings.position_size && this.userSettings.position_size == '1'){
                    this.onClickList[spreads].lot = this.onClickList[spreads].units / priceData.other.market_ContractSize
                }
                if(this.onClickList[spreads].lot > parseFloat(priceData.other.Max_Trade_Size)){
                    this.addErrorMsg(spreads+'_form_lot');
                    this.oneclickError('Quantity size shuld be maximum ' + (priceData.other.Max_Trade_Size * priceData.other.market_ContractSize),'error')
                    return
                }
                if(this.onClickList[spreads].units / priceData.other.market_ContractSize > parseFloat(priceData.other.Max_Trade_Size)){
                    this.oneclickError('Unit size shuld be maximum ' + (priceData.other.Max_Trade_Size * priceData.other.market_ContractSize),'error')
                    return
                }
                this.$store.commit('SET_WS_ORDER',{})
                const tempOrderId = new Date().getTime()
                let orderJson = {
                    "symbol" : spreads,
                    "quantity" : parseFloat(this.onClickList[spreads].lot),
                    "side" : side,
                    "stop" : parseFloat(this.onClickList[spreads].SL || 0),
                    "limit" : parseFloat(this.onClickList[spreads].TP || 0),
                    "trail" : 0,
                    "commentary" : '',
                    "account_id": this.get_user.profile.act_account_id,
                    "tempOrderId" : tempOrderId,
                    'localParams' : this
                }
                // console.log('order',orderJson)
                this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeOrder(orderJson)
                this.orderPending = orderJson
                this.tempOrderId = this.orderPending.tempOrderId
            }else{
                document.getElementById(spreads+'_lot').focus();
                this.addErrorMsg(spreads+'_form_lot');
                this.oneclickError('please enter valid lot size','error')
            }
        },
        changeClickList(){
            this.onClickList = {}
            const _that = this
            function isDivisible(quantity, minLot, precision = 10) {
                const scale = Math.pow(10, precision);
                const scaledQuantity = Math.round(quantity * scale);
                const scaledMinLot = Math.round(minLot * scale);
                return scaledQuantity % scaledMinLot === 0;
            }
            for (let index = 0; index < _that.subList.length; index++) {
                const val = _that.subList[index];
                let other = (_that.get_currencies[val] || {}).other || {}
                let lot = _that.userSettings.lotsize || 0.01;
                let min_lot = other.Min_Trade_Size;
                if(!isDivisible(lot,min_lot)){
                    lot = min_lot;
                }
                let units = lot * other.market_ContractSize;
                _that.onClickList[val] = { SL: '' , TP: '' , lot : lot, units }
            }
            
        },
    	editWAtch(){
            let _that = this
    		this.submitted =  true
    		this.$validator.validate().then(valid => {
		        if (valid) {
                    let inputJson = {
                        'globalParams' : {
                            'id' : _that.editWatchData._id,
                            'name' : _that.editWatchData.name
                        },
                        'localParams' : { 'parameter' : _that }
                    }
                    this._runUpdateWatchList(inputJson)
                }
            });
    	},
    	delWAtch(){
        	let inputJson = {
        		'globalParams' : {
        			'id' : this.delWatchData._id
        		},
        		'localParams' : { 'parameter' : this }
        	}
			this._runDeleteWatchList(inputJson)
    	},
    	clearCreateWatch(){
    		this.showCreateWatch = false;
    		this.submitted = false;
    		this.newWatchName = '';
    		this.createWatchSuccess = false;
    	},
    	AdWAtch(){
    		let _that = this
    		this.submitted =  true
    		this.$validator.validate().then(valid => {
		        if (valid) {
		        	let inputJson = {
		        		'globalParams' : {
		        			'name' : _that.newWatchName
		        		},
		        		'localParams' : { 'parameter' : _that }
		        	}
    				_that._runCreateWatchList(inputJson)
		        }
		    });
    	},
		getwatchName(watchId){
			try{
				return this.watchListData.filter(val => val._id === watchId)[0].name
			}catch(e){return '-'}
		},
		setWatch(list){
			this.watchId = list._id
			this.subList = (list.subscribe)?list.subscribe:[]
			this.fevList = (list.is_fav)?list.is_fav:[]
			localStorage.removeItem('watchId');
			localStorage.removeItem('subList');
			if(this.watchId == null){
                localStorage.setItem('watchId', 'null');
            }else{
                localStorage.setItem('watchId', this.watchId);
            }
            this.setToLocal(this.subList);
			// localStorage.setItem('subList', JSON.stringify(this.subList));
			// this.callWatchList((list.subscribe)?list.subscribe:[])
			// if(this.subList.length > 0){}
		},
        setToLocal(list){
            let ordersIsins = this.pendingOrderList.map(o => o.Symbol)
            ordersIsins = Array.from(new Set([...list, ...ordersIsins]));
            localStorage.setItem('subList', JSON.stringify(ordersIsins));
        },
		callWatchList(list){
			if(list){
				let _that = this
				try{
					_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].watchlist(list)
                    if(list.length && !list.includes(_that.loadChart)){
					    _that.changeChart(list[0])
                    }
				}catch(e){
					var interval = setInterval(function(){
						try{
							// _that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].watchlist(list)
							if(list.length &&!list.includes(_that.loadChart)){
                                _that.changeChart(list[0])
                            }
							clearInterval(interval);
						}catch(e){}
					}, 500)
				}
			}
		},
        checkSubscribe(item){
    		if(this.subList.includes(item)){
                this.changeChart(item)
    		}else if(this.subList.length < 20 || (product == 'Capital-Street' && this.subList.length < 50 && this.watchId)){
                this.addRemSubscribe(item);
                this.changeChart(item)
    		}else if(this.subList.length >= 20 || (product == 'Capital-Street' && this.subList.length >= 50)){
    			// this.displayError("you can add maximum 20 pair's in one Watch List",'error')
                this.displayError(this.watchId?`you can add maximum ${product == 'Capital-Street'?50:20 } pair's in one Watch List`:"Default list cannot be modified Please create new watchlist.",'error')
    		}
        },
    	addRemSubscribe(item){
    		let itemData ={ "isins": [item], "id": this.watchId }
    		if(this.subList.includes(item)){
                if(this.watchId){
                    this.subList = this.subList.filter(val => val != item)
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].unsubscribe(itemData)
                    if(this.loadChart == item && !this.subList.includes(this.loadChart) && this.subList.length > 0){
                        this.changeChart(this.subList[0])
                    }
                }else{
                    this.displayError("Default list cannot be modified Please create new watchlist.",'error')
                }
    		}else if(this.subList.length < 20 || (product == 'Capital-Street' && this.subList.length < 50 && this.watchId)){
				this.subList.push(item)
                // console.log('subscribe',itemData)
    			this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
				.seeders['S_PF_PF'].subscribe(itemData)
    		}else if(this.subList.length >= 20 || (product == 'Capital-Street' && this.subList.length >= 50)){
    			this.displayError(this.watchId?`you can add maximum ${product == 'Capital-Street'?50:20 } pair's in one Watch List`:"Default list cannot be modified Please create new watchlist.",'error')
    		}
    		let watchListData =  [...this.watchListData]
    		watchListData.forEach((val,index)=>{
				if(val._id === this.watchId){
					watchListData[index].subscribe = this.subList
					localStorage.setItem('subList', JSON.stringify(this.subList));
				}
			})
    		this.$store.commit('/SET_WATCH_LIST', watchListData)
    	},
    	addRemFev(item){
    		let itemData ={ "isins": [item], "id": this.watchId }
    		if(this.fevList.includes(item)){
                this.fevList = this.fevList.filter(val => val != item)
                this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                .seeders['S_PF_PF'].removeFavorite(itemData)
            }else if(this.fevList.length <= 20){
				this.fevList.push(item)
    			this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
				.seeders['S_PF_PF'].addFavorite(itemData)
    		}else if(this.subList.length >= 20){
                this.displayError("you can add maximum 20 pair's in fevorite List",'error')
            }
    		let watchListData =  [...this.watchListData]
    		watchListData.forEach((val,index)=>{
				if(val._id === this.watchId){
					watchListData[index].is_fav = this.fevList
				}
			})
			// console.log(item,this.fevList,watchListData)
    		this.$store.commit('/SET_WATCH_LIST', watchListData)
    	},
    	drag(ev,data) {
            ev.dataTransfer.setData("marketData", JSON.stringify(data));
        },
    	openBuySell(type,pair){
            this.tradeBuySell = true; 
            this.buySellType = type;
            this.currency_pair = pair;
        },
	    dataList(value){
			var data = Object.values(value)
	        try{
                const priority = {
                    forex: 1,
                    indicies: 2,
                    commodities: 3,
                    crypto: 4
                };
				if(data.length > 0 ){
					var _that = this
					if(this.filterType != 'ALL'){
						return data.filter( (val) => {
							return val.other && val.other.type.toLowerCase() == _that.filterType.toLowerCase()
						}).filter( (val) => {
							return this.subList.includes(val.other.isinid) && (!this.shoWFev || this.fevList.includes(val.other.isinid))
						}).sort((a, b) => a.other.isinid.localeCompare(b.other.isinid) );
                        // .sort((a, b) => priority[a.other.type.toLowerCase()] - priority[b.other.type.toLowerCase()] );
                        
					}
					else{
						return data.filter( (val) => {
							return val.other && this.subList.includes(val.other.isinid) && (!this.shoWFev || this.fevList.includes(val.other.isinid))
						})
                        // .sort((a, b) => priority[a.other.type.toLowerCase()] - priority[b.other.type.toLowerCase()] );
                        .sort((a, b) => {
                            // Primary sort by priority
                            const priorityDiff = priority[a.other.type.toLowerCase()] - priority[b.other.type.toLowerCase()];

                            // Secondary sort alphabetically by name if priorities are the same
                            if (priorityDiff === 0) {
                                return a.other.isinid.localeCompare(b.other.isinid);
                            }

                            return priorityDiff;
                        });
					}
				}else { return []}
	        }catch(e){
                console.log(e);
	           return [] 
	        }
		},
		watchLiting(){
			this._runGetWatchList({ 'globalParams' : {},'localParams' : { 'parameter' : this } })
		}
    },
    computed:{
        enableCrypto(){
            return product != 'Fxview' || this.currencyPairs.some(v => v.type == 'crypto');
        },
        enableShares(){
            return this.currencyPairs.some(v => v.type == 'Shares');
        },
        currencyPairsSorted(){
            return this.currencyPairs.sort((a, b) => {
                if (a.type === "Forex") return -1;
                if (b.type === "Forex") return 1;
                return a.type.localeCompare(b.type);
            });
        },
		get_currencies(){
			try {
				// just 'feel' the pulse here so we get a reactive response
				// as the cache is not reactive  
				this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
				return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
			} catch (ex) {
                // console.log(ex)
				// console.log('OO-one [ex]', ex)
				return []
			}
		}
	},
    mounted() {
		const _that = this
        $(document).on("click", function(event){
			if(!$(event.target).closest('.openHeader').length){
                _that.openHeader = false
            }
            if(!$(event.target).closest('.openBuySell').length){
                _that.buySell = ''
                _that.tradeBuySell = false
            }
        });
	},

	created(){
		let _that = this
		if(localStorage.getItem('watchId')){
			let watchId = localStorage.getItem('watchId');
            this.watchId = (watchId == 'null')?null:watchId
		}
        if(this.watchListData.length > 0){
            let idFound = false
            this.watchListData.forEach((val,index)=>{
                if(val._id === this.watchId){
                    idFound = true
                    this.fevList = (val.is_fav)?val.is_fav:[]
                    this.setWatch(val)
                }
                if(index == this.watchListData.length-1 && !idFound){
                    this.setWatch(this.watchListData[0])
                }
            })
        }
		else if(localStorage.getItem('subList')){
			this.subList =JSON.parse(localStorage.getItem('subList'));
			// this.callWatchList(this.subList)
		}
		this.watchLiting()
	}
    
}
</script>
<style>
    #app-custom-view .customWatch-list{
        height: 100%;
    }
    #app-custom-view .customWatch-list .customPad{
        height: 100%;
    }
    #app-custom-view .addWatchlist-step.scrollbar{
        height: 85% !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/website/shared/app-watchlist.vue